import React, { Component } from "react";
const CommonDownloadWrapper = (DownloadEmailAuthentication, DownloadOTPAuthentication, DownloadPasswordPage, DownloadVerification) => {
  return class extends Component {
    render() {
      if (this.props.location.state && this.props.location.state.page === "email") {
        return <DownloadEmailAuthentication {...this.props} />;
      }
      else if (this.props.location.state && this.props.location.state.page === "verify") {
        return <DownloadVerification {...this.props} />;
      }
      else if (this.props.location.state && this.props.location.state.page === "otp") {
        return <DownloadOTPAuthentication {...this.props} />;
      }
      else if (this.props.location.state && this.props.location.state.page === "password") {
        return <DownloadPasswordPage {...this.props} />;
      }
    }
  };
};
export default CommonDownloadWrapper;